import { useMemo } from "react";
import { useApiContext } from "../components/api/ApiContext";
import AccountService from "../services/AccountService";

const useAccountService = () => {
  const { client } = useApiContext();
  const service = useMemo(() => {
    return new AccountService(client);
  }, [client]);

  return service;
};

export default useAccountService;
